export default __webpack_public_path__ + "static/media/photo9.32b69aea.jpg";